;(function (win) {
  var doc = win.document
  var docEl = doc.documentElement
  var tid

  function refreshRem() {
    // 获取当前窗口宽度
    var width = docEl.getBoundingClientRect().width

    // --- PC端适配逻辑 ---
    // 1. 如果屏幕太小（小于1200px），通常不希望字体无限缩小导致由于布局崩坏
    // 此时锁定宽度为 1200px 去计算 rem
    var adaptWidth = width
    if (width < 1200) adaptWidth = 1200
    // if (width > 1920) adaptWidth = 1920 // 屏幕超过1920（比如2K/4K屏），文字和组件不再变大，保持1920的效果居中即可

    // 2. 假设设计稿是 1920px，设定 1rem = 100px
    // 计算公式：当前宽度 / 设计稿宽度 * 100
    var rem = (adaptWidth / 1920) * 100

    // 3. 直接修改根元素的字体大小
    docEl.style.fontSize = rem + 'px'

    // 兼容性：部分老旧代码可能会用到 window.rem
    win.rem = rem
  }

  // 监听窗口大小变化（带 300ms 防抖，防止频繁计算卡顿）
  win.addEventListener(
    'resize',
    function () {
      clearTimeout(tid)
      tid = setTimeout(refreshRem, 300)
    },
    false
  )

  // 监听页面显示（处理浏览器后退时的缓存问题）
  win.addEventListener(
    'pageshow',
    function (e) {
      if (e.persisted) {
        clearTimeout(tid)
        tid = setTimeout(refreshRem, 300)
      }
    },
    false
  )

  // 初始化执行一次
  refreshRem()
})(window)
